export default __webpack_public_path__ + "static/media/img9.0e6e9c1a.PNG";